module.exports = __webpack_public_path__ + "static/media/icon-left.a121995c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-left.svg
// module id = 864
// module chunks = 7